import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ReactComponent as MarketingBannerIcon } from '../../assets/icons/marketing-banner-icon.svg';

const MarketingBanner = () => {
    const { formatMessage } = useIntl();
    return (
        <div className="marketing-banner-wrapper">
            <div className="marketing-banner">
                <MarketingBannerIcon />
                <h1>
                    <FormattedMessage id="marketing.banner.heading" />
                </h1>
                <p>
                    <FormattedMessage id="marketing.banner.content" />
                </p>
                <a href={formatMessage({ id: 'marketing.banner.link' })} rel="noopener noreferrer" target="_blank">
                    <FormattedMessage id="marketing.banner.link.text" />
                </a>
            </div>
        </div>
    );
};
export default MarketingBanner;
